import { motion } from "framer-motion";

const CTA_IMG =
  "https://images.unsplash.com/photo-1624373784580-f9d3e67991d2?crop=entropy&cs=srgb&fm=jpg&q=85";

const reveal = (delay = 0) => ({
  initial: { opacity: 0, y: 28 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, amount: 0.15 },
  transition: { duration: 0.7, delay, ease: [0.16, 1, 0.3, 1] },
});

const STEPS = [
  { n: "01", t: "Add the fleet", d: "Reg plate, make, category — taxi, private hire, van or the family runabout. Two minutes per car." },
  { n: "02", t: "Pin the dates", d: "MOT, council test and road tax due dates go on one garage wall — each with its own countdown." },
  { n: "03", t: "We email first", d: "Alerts land at 30, 14, 7 and 1 day out, plus on the day. Renew in the dashboard and the countdown resets." },
];

export default function HowItWorks({ onLaunch }) {
  return (
    <section id="reminders" className="py-24 md:py-32 border-t border-line">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <motion.div {...reveal()} className="max-w-2xl">
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-ember">How it runs</p>
          <h2 className="font-display text-4xl md:text-6xl font-black uppercase tracking-wide mt-4 leading-[0.95]">
            Three moves to a quiet mind.
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6 mt-14">
          {STEPS.map((s, i) => (
            <motion.div key={s.n} {...reveal(i * 0.08)} className="rounded-2xl border border-line bg-panel p-7 hover:border-linehi transition-colors duration-300">
              <p className="font-mono text-sm text-ember tracking-[0.2em]">{s.n}</p>
              <h3 className="font-display text-2xl font-bold uppercase tracking-wide mt-4">{s.t}</h3>
              <p className="text-mid text-sm mt-3 leading-relaxed">{s.d}</p>
            </motion.div>
          ))}
        </div>

        <motion.div
          {...reveal(0.1)}
          className="relative mt-20 rounded-3xl overflow-hidden border border-linehi"
          data-testid="cta-band"
        >
          <img src={CTA_IMG} alt="" className="absolute inset-0 w-full h-full object-cover opacity-30 spotlight" />
          <div className="absolute inset-0 bg-gradient-to-r from-ink via-ink/80 to-ink/40" />
          <div className="relative px-8 md:px-14 py-16 md:py-24">
            <h2 className="font-display font-black uppercase leading-[0.9] tracking-wide text-5xl md:text-7xl">
              Stop remembering.<br />
              <span className="text-ember">Start driving.</span>
            </h2>
            <div className="flex flex-wrap items-center gap-6 mt-9">
              <button
                data-testid="cta-launch-button"
                onClick={onLaunch}
                className="rounded-full bg-ember px-8 py-4 font-display text-xl font-bold uppercase tracking-wider text-ink hover:bg-ember/90 transition glow-ember"
              >
                Launch Command
              </button>
              <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-mid">
                Private by default — your email &amp; password, your fleet
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
